// extracted by mini-css-extract-plugin
export var closeButton = "_c1-1";
export var closeX = "_c1-3";
export var container = "_c1-0";
export var image = "_c1-2";